
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('react-helmet'),
    Helmet = _require.Helmet;

var Link = require('@npm/spiferack/link');
var PropTypes = require('prop-types');
var React = require('react');

var PasswordCriteria = require('../../components/auth/password-criteria');
var EmailPolicyNote = require('../../components/auth/email-policy-note');
var PasswordInput = require('../../components/inputs/password');
var UsernameInput = require('../../components/inputs/username');
var Checkbox = require('../../components/inputs/checkbox');
var EmailInput = require('../../components/inputs/email');
var LiminalLoginLayout = require('../../components/layouts/liminal-login');

var _require2 = require('./liminal-login-footer'),
    SignupFooter = _require2.SignupFooter;

var Captcha = require('../../components/captcha/captcha');
var Form = require('../../components/forms/generic');
var forms = require('../../styles/forms.css');
var styles = require('./auth.css');
var types = require('../../types');

var SignUpPage = function (_React$Component) {
  _inherits(SignUpPage, _React$Component);

  function SignUpPage(props) {
    _classCallCheck(this, SignUpPage);

    var _this = _possibleConstructorReturn(this, (SignUpPage.__proto__ || Object.getPrototypeOf(SignUpPage)).call(this, props));

    _this.state = {
      displayCaptcha: false,
      disableSubmitButton: _this.props.showCaptcha
    };
    _this.setSubmitButtonDisable = _this.setSubmitButtonDisable.bind(_this);
    return _this;
  }

  _createClass(SignUpPage, [{
    key: 'eulaCheckBoxValidity',
    value: function eulaCheckBoxValidity(event) {
      var target = event.target;

      var valid = target.checkValidity ? target.checkValidity() : true;
      if (this.state.displayCaptcha !== valid) {
        this.setState({ displayCaptcha: valid });
      }
    }
  }, {
    key: 'setSubmitButtonDisable',
    value: function setSubmitButtonDisable(buttonState) {
      if (this.state.disableSubmitButton !== buttonState) {
        this.setState({ disableSubmitButton: buttonState });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          action = _props.action,
          next = _props.next,
          _props$formData = _props.formData,
          formData = _props$formData === undefined ? {} : _props$formData,
          showCaptcha = _props.showCaptcha;

      var Footer = React.createElement(SignupFooter, { next: next });
      var passwordCriteriaMessage = 'Minimum of 10 characters and must meet our ';
      return React.createElement(
        LiminalLoginLayout,
        { Footer: Footer },
        React.createElement(
          'div',
          { className: styles.signup },
          React.createElement(
            Helmet,
            null,
            React.createElement(
              'title',
              null,
              'npm | Sign Up'
            )
          ),
          React.createElement(
            Form,
            {
              action: action,
              buttonText: 'Create an Account',
              onSubmit: function onSubmit() {} // noop to force a page re-load
              , formId: 'signup',
              formData: formData,
              disabled: this.state.disableSubmitButton,
              className: 'ma0',
              buttonAriaLabel: 'Create an Account'
            },
            React.createElement(
              'h1',
              { className: forms.liminalHeading },
              'Sign Up'
            ),
            React.createElement(UsernameInput, { className: forms.userNameInputSignup, label: 'Username *', name: 'name', formData: formData }),
            React.createElement(EmailInput, { label: 'Email address', name: 'email', formData: formData, ariaDescribedby: 'email-policy-note' }),
            React.createElement(EmailPolicyNote, { className: forms.emailPolicySignup }),
            React.createElement(PasswordInput, {
              label: 'Password',
              name: 'password',
              showToggleButton: true,
              formData: formData,
              ariaDescribedby: 'password-criteria'
            }),
            React.createElement(PasswordCriteria, { className: forms.passwordCriteriaSignup, message: passwordCriteriaMessage }),
            React.createElement(
              'fieldset',
              { className: forms.eulaSignup },
              React.createElement(Checkbox, {
                name: 'eula-agreement',
                ariaLabel: 'I agree to the End User License Agreement and Privacy Policy *',
                required: true,
                formData: formData,
                label: React.createElement(
                  'span',
                  null,
                  'I agree to the',
                  ' ',
                  React.createElement(
                    Link,
                    null,
                    React.createElement(
                      'a',
                      { href: '/policies/terms', target: '_blank' },
                      'End User License Agreement'
                    )
                  ),
                  ' ',
                  'and the',
                  ' ',
                  React.createElement(
                    Link,
                    null,
                    React.createElement(
                      'a',
                      { href: '/policies/privacy', target: '_blank' },
                      'Privacy Policy'
                    )
                  ),
                  '. *'
                ),
                onChange: function onChange(event) {
                  _this2.eulaCheckBoxValidity(event);
                }
              })
            ),
            this.state.displayCaptcha && showCaptcha && React.createElement(Captcha, { formId: 'signup', formData: formData, setSubmitButtonDisable: this.setSubmitButtonDisable })
          )
        )
      );
    }
  }]);

  return SignUpPage;
}(React.Component);

SignUpPage.layout = 'none';

SignUpPage.propTypes = {
  action: PropTypes.string.isRequired,
  formData: types.formData
};

module.exports = SignUpPage;
  let __hot__
  
  __registry__.register('auth/signup', module.exports, __hot__)
  